<div class="dynamic-form-component {{ dynamicFormOptions.class }}">
  <form [formGroup]="dynamicForm">
    <fieldset [disabled]="isSubmitting">
      <div class="field-container d-flex ">
        @for (column of fieldColumns; track column; let i = $index) {
          <div class="field-column">
            @for (field of fieldColumns[i]; track field) {
              <div class="form-group">
                @if (field.type !== 'hidden') {
                  <label>{{ field.label | translate }}</label>
                }
                @switch (field.type) {
                  @case ('div') {
                    <textarea
                      spellcheck="false"
                      style="min-width: 500px; min-height: 940px; color: #333; background-color: white; font-size: 10px !important"
                      [formControlName]="field.id"
                      class="form-control"
                    ></textarea>
                  }
                  @case ('text') {
                    <input type="text" class="form-control" [id]="field.id" [formControlName]="field.id" />
                  }
                  @case ('text') {
                    <input type="hidden" class="form-control" [id]="field.id" [formControlName]="field.id" />
                  }
                  @case ('select') {
                    @if (field | selectObservable : dynamicFormOptions | async; as fieldOptions) {
                      <select
                        class="form-control"
                        [formControlName]="field.id"
                        [id]="field.id"
                        >
                        @for (option of fieldOptions; track option) {
                          <option [value]="option.value">
                            {{ option.key }}
                          </option>
                        }
                      </select>
                    } @else {
                      <span class="loading"><span class="dot">.</span><span class="dot">.</span><span class="dot">.</span></span>
                    }
                  }
                  @case ('checkbox') {
                    <input type="checkbox" class="form-control" [id]="field.id" [formControlName]="field.id" />
                  }
                  @case ('date') {
                    <input
                      class="form-control"
                      ngbDatepicker
                      #datePicker="ngbDatepicker"
                      (focus)="datePicker.open()"
                      [restoreFocus]="'body'"
                      [autoClose]="true"
                      [id]="field.id"
                      [formControlName]="field.id"
                      />
                    }
                    @case ('textarea') {
                      <textarea class="form-control" [id]="field.id" [formControlName]="field.id"></textarea>
                    }
                  }
                </div>
              }
            </div>
          }
        </div>
      </fieldset>
      <div class="d-flex flex-row justify-content-between flex-wrap" >
        @if (dynamicFormOptions.deleteFormUrl) {
          <button type="button" class="btn btn-danger mw-100" [disabled]="isSubmitting" (click)="deleteItem()">
            @if (!isSubmitting) {
              {{ "DELETE" | translate }}
            } @else {
              <span class="loading"><span class="dot">.</span><span class="dot">.</span><span class="dot">.</span></span>
            }
          </button>
        }

        <button type="button" class="btn btn-primary mw-100" [disabled]="isSubmitting" (click)="submitForm()">
          @if (!isSubmitting) {
            {{ "SUBMIT" | translate }}
          } @else {
            <span class="loading"><span class="dot">.</span><span class="dot">.</span><span class="dot">.</span></span>
          }
        </button>
      </div>

      @if (successMessage) {
        <div class="mt-3 mb-3" [innerHtml]="successMessage"></div>
      }
    </form>
    <!--<pre>{{ this.dynamicForm.getRawValue() | json }}</pre>-->
  </div>

